import { StoreType } from "@reducers/types";
import { AprListState } from "@reducers/types/HRM/apr-list-state";

export const getAprListState = (state: StoreType): AprListState =>
  state.hrm.aprList;
